import React from 'react';
import NinjaTable from 'components/tables/NinjaTable';
import { Tag } from 'antd';
import { DateFormatter } from 'components/charts/formatters';
import getFormattedNumber from 'store/redux/utils/getFormattedNumber';
import { useJourneyReport } from 'modules/ReportModule/context/useJourneyReport';

const EventsOverviewTable = () => {
  const { filter } = useJourneyReport();

  const columns = [
    {
      key: 'name',
      name: 'Name ',
      renderCell: ({ row }) =>
        row.name ? <div className='flex font-semibold text-info'>{row.name}</div> : '-',
    },
    {
      key: 'volume',
      name: 'Volume ',
      renderCell: ({ row }) => (
        <Tag bordered={false} className='font-medium'>
          {getFormattedNumber(row.volume)}
        </Tag>
      ),
    },
    {
      key: 'percentage_of_volume',
      name: '% of volume ',
      renderCell: ({ row }) => (
        <Tag bordered={false} className='font-medium'>
          {getFormattedNumber(row.percentage_of_volume)} %
        </Tag>
      ),
    },
    {
      key: 'first_seen',
      name: 'First seen ',
      renderCell: ({ row }) => (
        <DateFormatter date={row.first_seen} format='MMM DD, YYYY' className='font-medium' />
      ),
    },
    {
      key: 'last_seen',
      name: 'Last seen ',
      renderCell: ({ row }) => (
        <DateFormatter date={row.last_seen} format='MMM DD, YYYY' className='font-medium' />
      ),
    },
  ];

  return (
    <NinjaTable
      cardProps={{ disable: true }}
      title='Events Overview'
      dataProvider='eventsOverview'
      columns={columns}
      queryParams={{
        filters: {
          ...filter,
        },
      }}
    />
  );
};

export default EventsOverviewTable;
